import { prepareStore } from "saga-query";
import { createReducerMap } from "robodux";
import { loadingBarReducer as loadingBar } from "react-redux-loading-bar";
import { api, thunks, inApi, inThunks } from "./api";
import { fsSvnRepo } from "../units";
import { fsHomesRepo } from "../units";
import { anafRepo, malinkRepo } from "../units";
import { groupsRepo } from "../units";
import { loginRepo } from "../units";
import {
  repoUiDrawer,
  repoProfTreeList,
  repoGroupTreeList,
  repoShowCaseTree,
} from "../units";
import { repoUserTreeList } from "../units";
import { usersRepo } from "../units";
import { adminRepo } from "../units";
import { utilsRepo } from "../units";
import { repoShowCases } from "../units";
import { dirinfoType, dirinfoData } from "../units";
import { uiDirifo } from "../units";
import { uiFileOps } from "../units";

import { chooserRepo as insiderDrawer } from "../insider/ui/drawer";
import { insLogin as insiderLogin } from "../insider/login";
import {
  repoUi as insiderUi,
  repoListModels as insiderReportModels,
} from "../insider/ui/uiList";
import { repo as insiderLists } from "../insider/lists";
import { repo as insiderProfiles } from "../insider/profilesApi";
import { repo as insiderDownloads } from "../insider/instorage";
import { persistorGuard } from "../units/persistorGuard";
// import { repo_collected_ifiscal } from "../insider/colection";
// import {
//   repo as insiderCurrencyDomains,
//   repo_accounts as insiderAccounts,
// } from "../insider/currencyDomain";
// import { repo as insiderFiscal } from "../insider/invoiceFiscal";
// import { repo as insiderTrackTree } from "../insider/ui/invoiceTrack";
// import { repo as insiderCurrencyRates } from "../insider/currencyRates";
//
import rootSaga from "../rootSaga";

export const reducers = createReducerMap(
  persistorGuard,
  adminRepo,
  anafRepo,
  loginRepo,
  malinkRepo,
  fsHomesRepo,
  fsSvnRepo,
  groupsRepo,
  repoUiDrawer,
  repoProfTreeList,
  repoUserTreeList,
  repoGroupTreeList,
  repoShowCaseTree,
  repoShowCases,
  usersRepo,
  uiFileOps,
  utilsRepo,
  dirinfoType,
  dirinfoData,
  uiDirifo,
  insiderDownloads,
  insiderDrawer,
  insiderLists,
  insiderLogin,
  insiderProfiles,
  insiderReportModels,
  insiderUi,
  {
    name: "loadingBar",
    reducer: loadingBar,
  }
);

export const apiStore = prepareStore({
  reducers,
  sagas: {
    0: api.saga(),
    1: thunks.saga(),
    2: rootSaga,
    3: inApi.saga(),
    4: inThunks.saga(),
  },
});

export { api, thunks } from "./api";
export const rootReducer = apiStore.reducer;
export type RootReducer = ReturnType<typeof rootReducer>;
